import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Skeleton } from "@portal/BaseComponents/Skeleton/AntSkeleton";
import { StyledTile } from "@portal/BaseComponents/SnapShotTile/style";
import { Statistic } from "@portal/BaseComponents/Statistic/AntStatistic";
import { cellComponents } from "@portal/BaseComponents/Table/Components/cellComponents";
import {
  InvoicesColumnProps,
  InvoicesColumns,
} from "@portal/BaseComponents/Table/Components/Invoices/InvoicesColumn";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { Icon } from "@portal/lib/icons/icons";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";

import { DateText } from "@portal/BaseComponents/Date/DateText";
import { formatCurrency } from "@portal/util/number-formatter";
import { useAtomValue } from "jotai";
import { sum } from "lodash";
import { useMemo } from "react";
import { getPaymentModeLabel } from "../../PotalTabs/Payment/predicate";
import { TileProps } from "../type";

const t = {
  title: "Recent Payment",
};

const PaymentIcon = (
  <Icon icon={["far", "credit-card"]} color="var(--green-6)" fontSize={12} />
);
function RecentPayments(props: TileProps) {
  const { loading, data } = props;
  const customerCurrency =
    useAtomValue(userConfigAtom).user_details?.customer.currency;
  const Title = <TypographyText fs={"16"}>{t.title}</TypographyText>;
  const Amount = (
    <Statistic
      title={Title}
      prefix={PaymentIcon}
      value={formatCurrency(data?.recent_payment?.amount_customer_currency, {
        currency: customerCurrency ?? "USD",
      })}
      valueStyle={{
        fontSize: "var(--fs-16)",
        fontWeight: "var(--fs-semibold)",
      }}
    />
  );

  const PaymentMode = (
    <TypographyText>
      {getPaymentModeLabel(data?.recent_payment?.mode)}
    </TypographyText>
  );

  function getInvoices(): InvoicesColumns[] | undefined {
    return data?.recent_payment?.invoices?.map((invoice) => {
      return {
        id: invoice.id,
        title: invoice.number,
        amount: sum(
          data.recent_payment?.invoice_payments[invoice.id].map((f) => f.amount)
        ),
        currency: invoice.currency,
      };
    });
  }
  const invoice = useMemo(getInvoices, [
    data?.recent_payment?.invoice_payments,
    data?.recent_payment?.invoices,
  ]);

  const Invoices = cellComponents.invoices({
    value: invoice ?? [],
    style: { flexDirection: "row", gap: "var(--space-4)" },
  } as InvoicesColumnProps<any>);

  const Date = data?.recent_payment?.date && (
    <DateText
      value={data?.recent_payment.date}
      textProps={{
        fs: "12",
        style: { color: "var(--gray-8)" },
      }}
    />
  );

  return (
    <StyledTile size="sm" layout="l1">
      <Skeleton loading={loading} active>
        <Flex vertical align="flex-start">
          <Flex vertical space={"4"}>
            {Amount}
            {PaymentMode}
          </Flex>
          <Flex vertical space={"4"}>
            {Invoices}
            {Date}
          </Flex>
        </Flex>
      </Skeleton>
    </StyledTile>
  );
}

export { RecentPayments };
